export const DEFAULT_TIME_INTERVAL = 15;
export const HALF_HOUR = 30;
export const FULL_HOUR = 60;
